<template>
   <div class="radio-block mb-1 flex min-h-12 w-full cursor-pointer items-center rounded-md last-of-type:mb-0">
      <input
         :id="id"
         :value="value"
         :name="group"
         type="radio"
         :checked="isSelected"
         class="absolute right-0 z-1 mr-6 size-5 cursor-pointer"
         @change="onInput"
      />
      <label :for="id" class="radio-block-label flex min-h-12 w-full cursor-pointer items-center rounded-md text-black">
         <span class="py-2 pl-4 pr-16">{{ label }}</span>
      </label>
   </div>
</template>

<script setup lang="ts">
const props = defineProps({
   id: {
      type: String,
      required: true,
   },
   value: {
      type: String,
      required: true,
   },
   label: {
      type: String,
      required: true,
   },
   group: {
      type: String,
      required: true,
   },
   isSelected: {
      type: Boolean,
      default: false,
   },
});

const emit = defineEmits(["option-selected"]);

function onInput() {
   emit("option-selected", props.value);
}
</script>

<style lang="scss" scoped>
@use "@/assets/mixins.scss" as mixins;

.radio-block input {
   accent-color: var(--colour-brand-default);
}

// remove outline from input and add it to the label instead
.radio-block input:focus-visible {
   outline: none !important;
   box-shadow: none;

   & + label {
      @include mixins.focus-outline;
   }
}

.radio-block input:checked {
   accent-color: var(--colour-brand-default);
}
.radio-block input:checked + .radio-block-label {
   background: var(--grey-10);
   color: var(--black);
}
</style>
